import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { of } from 'rxjs';
import { switchMap, map, tap } from 'rxjs/operators';
import { RouteService } from '@services/route.service';
import { GlobalService } from '@services/global.service';
import { Marque, Filter } from '@models/product';

@Component({
  selector: 'gob-marque-form',
  templateUrl: './marque-form.component.html',
  styleUrls: ['./marque-form.component.css']
})
export class MarqueFormComponent implements OnInit {
  loading: boolean=false;
  error: string;
  msg: string;
  marque: Marque;
  filters: Filter[]=[];

  constructor(public route: RouteService, private router: ActivatedRoute, private gServ: GlobalService) {
    this.loading=true;
    this.marque=new Marque();
    this.router.paramMap
      .pipe(
        switchMap(params => {
          if(params.get('id')){
            return this.gServ.getMarques()
                      .pipe(
                        map(marques => marques.find(c => c.ident==params.get('id'))),
                        tap(marque => this.marque=JSON.parse(JSON.stringify(marque)))
                      );
          }
          else
            return of(new Marque());
        }),
        switchMap(() => this.gServ.getFilters()),
        tap(filters => this.filters=filters)
      )
      .subscribe({
        next: () => this.loading=false,
        error: e => {
          this.error=e;
          this.loading=false;
        }
      });
  }

  ngOnInit(): void {
  }

  isActive(ident: string){
    return (this.marque.filters.findIndex(filter => filter==ident)!=-1 || this.isDefault(ident));
  }

  isDefault(ident: string){
    return (ident=="filter-price" /* || ident=="filter-age" || ident=="filter-players" */);
  }

  setFilter(ident: string, event: any){
    if(event.target.checked)
      this.marque.filters.push(ident);
    else
      this.marque.filters.splice(this.marque.filters.findIndex(filter => filter==ident), 1);
  }

  update(form: any){
    this.loading=true;
    let update: boolean=(this.marque.ident!=null);
    this.gServ.setMarque(this.marque).subscribe({
      next: () => {
        this.msg='Modification enregistrée';
        if(!update)
          form.reset();
        this.loading=false;
      },
      error: e => {
        this.error=e;
        this.loading=false;
      }
    });
  }

  rm(){
    if(confirm("Etes-vous sur de vouloir supprimer ?")){
      this.loading=true;
      this.gServ.rmMarque(this.marque.ident).subscribe({
        next: () => this.route.navigate('class-list'),
        error: e => {
          this.error=e;
          this.loading=false;
        }
      });
    }
  }
}
